// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contentDIV {
    position: relative;
    overflow: auto;
}

.leftColumn {
    border-right: 1px solid black;
    width: 250px;
}

.moduleItem {
    background: gray;
    position: absolute;
}

.dropDIV {
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0px;
    left: 0px;
    z-index: 1;
}

.treeDiv {
    overflow: hidden;
}

`, "",{"version":3,"sources":["webpack://./src/app/components/dialogs/datadescription/datadescription.control.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".contentDIV {\n    position: relative;\n    overflow: auto;\n}\n\n.leftColumn {\n    border-right: 1px solid black;\n    width: 250px;\n}\n\n.moduleItem {\n    background: gray;\n    position: absolute;\n}\n\n.dropDIV {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    top: 0px;\n    left: 0px;\n    z-index: 1;\n}\n\n.treeDiv {\n    overflow: hidden;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
